// ── Single source of truth for app version ───────────────────────────────
// Update this whenever you bump VersionChecker.js APP_VERSION
// Format: Major.Minor.Patch.Build
const APP_VERSION_STRING = "312.00.00.00";
const APP_VERSION_NUMBER = 5; // must match APP_VERSION in VersionChecker.js

export { APP_VERSION_STRING, APP_VERSION_NUMBER };
export default APP_VERSION_STRING;